import styled from "styled-components";
import StepBar from "../StepBar";
import {device} from "../../helper/constants";

const Wrapper = styled.div`
    width: 100%;
    height: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #C5C5B7;

    @media ${device.mobile} {
      height: 90px;
    }
        
`;

const StepWrapper = styled.div`
    width: 32px;
    height: 32px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border-radius: 16px;
    color: #144344;
    font-size: 21px;
    font-weight: bold;
`;

const TextContainer = styled.div`    
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const ButtonContainer = styled.div`
    display: flex;
    width: 40px;
    height: 24px;
    position: relative;
`;

const TextHeader = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    padding: 20px;
    
    & span.title {
        font-size: 21px;
        font-weight: bold;
        color: #144344;
    }
    @media ${device.mobile} {
        padding: 15px;
        gap: 10px;
        & span.title {
            font-size: 17px;
        }
    }
`;

const StepBarContainer = styled.div`
    width: 100%;
    max-width: 500px;
    padding: 0 15px 15px 15px;
    gap: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    @media ${device.tablet} {
        gap: 15px;
    }
    @media ${device.mobile} {
        display: none;
    }
`;

const STEP = {
    1 : "Choisissez votre matériau",
    2 : "Choisissez votre finition",
    3 : "Sélectionnez une épaisseur",
    4 : "Choisissez la quantité"
}
export default function DXFStepHeader({step, isFromUrl, goBackHandler, minStepBack}) {

    return (
        <Wrapper>
            <TextHeader>
                <ButtonContainer>
                    {step > minStepBack && step > 1 && (!isFromUrl || (isFromUrl && step > 3) ) &&
                        <img title="Précédent" style={{cursor: "pointer", width: "24px"}} src={"/wp-content/uploads/2023/09/icon-arr-left.png"} alt={"Précédent"} onClick={goBackHandler}/>
                    }
                </ButtonContainer>
                <TextContainer>
                    <StepWrapper>{step}</StepWrapper>
                    <span className="title">{STEP[step]}</span>
                </TextContainer>
                <ButtonContainer>
                    <button className="lity-close hjt" type="button" aria-label="Close (Press escape to close)"
                            data-lity-close="">×
                    </button>
                </ButtonContainer>
            </TextHeader>
            <StepBarContainer>
                <StepBar isCurrent={step === 1} forDxf/>
                <StepBar isCurrent={step === 2} forDxf/>
                <StepBar isCurrent={step === 3} forDxf/>
                <StepBar isCurrent={step === 4} forDxf/>
            </StepBarContainer>
        </Wrapper>
    );
}